import { render, staticRenderFns } from "./HomeUserTemplateList.vue?vue&type=template&id=32f7460d&scoped=true&"
import script from "./HomeUserTemplateList.vue?vue&type=script&lang=js&"
export * from "./HomeUserTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f7460d",
  null
  
)

export default component.exports